import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GetOrganizationMemberNamePipe } from './get-organization-member-name.pipe';

@NgModule({
  declarations: [GetOrganizationMemberNamePipe],
  exports: [GetOrganizationMemberNamePipe],
  imports: [CommonModule],
})
export class OrganizationMemberModule {}
